export default __webpack_public_path__ + "static/media/rede.fw.42576df7.png";